<template>
  <a-modal
    v-model:open="open"
    destroy-on-close
    :width="loginPopoverProps[currentType]?.width"
    :height="loginPopoverProps[currentType]?.height"
    :centered="true"
    :footer="null"
    :title="loginPopoverProps[currentType]?.title || ''"
    :maskClosable="currentType === 'select'"
    :wrapClassName="loginPopoverProps[currentType]?.className || ''"
    @cancel="showAccountType = null"
  >
    <AccountLogin v-if="currentType === 'login'" :loginType="loginType" />
    <AccountReset v-if="currentType === 'reset'" />
    <AccountSelect v-if="currentType === 'select'" />
  </a-modal>
</template>

<script lang="ts" setup>
import AccountLogin from './login/index.vue'
import AccountReset from './reset/index.vue'
import AccountSelect from './select/index.vue'
import { loginPopoverProps as getLoginPopoverProps } from '~/constants/login'
// 页面内切换账号使用了
const loginPopoverProps = getLoginPopoverProps()

const showAccountType = useAccountType()
const loginType = ref('phone')

const open = ref(false)
const currentType = ref()

watch(
  () => showAccountType.value,
  (cur, before) => {
    if (cur !== before && cur) {
      open.value = true
      currentType.value = cur
    } else {
      open.value = false
    }
  },
  { immediate: true }
)

provide('loginType', loginType)
</script>

<style lang="scss">
.account-login-modal {
  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
    height: 100%;
  }

  .ant-modal-body {
    height: 100%;
  }
}
.reset-account-modal {
  .ant-modal-content {
    height: 100%;
  }
  .ant-modal:not(.ant-modal-confirm) .ant-modal-body {
    padding: 0;
    // padding-top: 16px;
    border-bottom: none;
    height: calc(100% - 50px);
  }
  .footer {
    @apply bg-secondary-6 mt-[40px] flex items-center text-[12px] justify-center;
    height: 40px;
    border-radius: 0 0 6px 6px;
  }
}
</style>
